import Form1099 from './Form1099'

export default Form1099
